import blueCardSprite from '../assets/sprites/level-up-card-blue.webp';
import redCardSprite from '../assets/sprites/level-up-card-red.webp';

const CARD_LEVEL_UP_SPRITES = {
  2: blueCardSprite,
  3: redCardSprite,
};

export function getCardLevelUpAnimation(level) {
  return {
    animationSpriteSrc: CARD_LEVEL_UP_SPRITES[Math.min(3, level)] || '',
    animationFrameCount: 16,
    animationFrameSize: 128,
    animationDurationMs: 1000,
  };
}
